export default __webpack_public_path__ + "static/media/speakers__matt-bischoff.cdb86c73.jpg";